import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import { dollarAmount } from 'common/display/Money/DollarAmount';
import { DetailList } from './Layout';
import { BaseLineItem } from './LineItems';

const FeeScheduleProgramSection = ({ feeScheduleProgram, isLoaded, isCostBased }) => {
  const unitRateValue = feeScheduleProgram.unit_rate ?
    `${dollarAmount(feeScheduleProgram.unit_rate, true)} per ${feeScheduleProgram.unit}` :
    'N/A';

  return (
    <DetailList>
      <BaseLineItem field="Contracted Program" isLoaded={isLoaded} dataTestElement="request-contracted-program">
        {feeScheduleProgram.name}
      </BaseLineItem>
      <BaseLineItem field="Payment Approach" isLoaded={isLoaded} dataTestElement="payment-approach">
        {fspUtils.PAYMENT_TYPES[feeScheduleProgram.payment_type]}
      </BaseLineItem>
      {!isCostBased && (
        <>
          <BaseLineItem field="Unit" isloaded={isLoaded} dataTestElement="request-unit">
            {capitalize(feeScheduleProgram.unit)}
          </BaseLineItem>
          <BaseLineItem field="Rate" isLoaded={isLoaded} dataTestElement="request-rate">
            {unitRateValue}
          </BaseLineItem>
        </>
      )}
      <BaseLineItem field="Program Cap" isLoaded={isLoaded} dataTestElement="request-cap">
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: feeScheduleProgram.cap_information || 'N/A' }} />
      </BaseLineItem>
    </DetailList>
  );
};

FeeScheduleProgramSection.propTypes = {
  feeScheduleProgram: PropTypes.shape({
    name: PropTypes.string,
    payment_type: PropTypes.string,
    unit: PropTypes.string,
    unit_rate: PropTypes.number,
    cap_information: PropTypes.string,
  }).isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isCostBased: PropTypes.bool.isRequired,
};

export default FeeScheduleProgramSection;
